import { loginToken, logout } from "./api/user";

export function useDiskoServerAuthentication() {
  return {
    loginToken,
    logout,
  };
}
